import { render, staticRenderFns } from "./TickerProperty.vue?vue&type=template&id=15d34410&"
import script from "./TickerProperty.vue?vue&type=script&lang=js&"
export * from "./TickerProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports